import { render, staticRenderFns } from "./DeliveryImportDialog.vue?vue&type=template&id=fbdfe0e8&"
import script from "./DeliveryImportDialog.vue?vue&type=script&lang=ts&"
export * from "./DeliveryImportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports